import './styles/AgreementBox.scss';
import { Fragment, useState, useEffect, useRef } from 'react';

interface Props {
    message: string, SetMessage: any,
    SetUsersAgreement: any
}

const AgreementBox: React.FC<Props> = ({ message, SetMessage, SetUsersAgreement }) => {
    //states
    const [agreed, SetAgreed] = useState(false);

    //refs
    const checkInRef = useRef<any>(null);

    //ui functions
    const OnAgreementDoneClicked = () => {
        SetUsersAgreement(true);
        SetMessage('');
    }


    return(
        message.length > 0 ?
        <div className='AgreementBox'>
            <span className='AgreementBox-scroll'>{message}</span>
            <div className='AgreementBox-checkrow'>
                <input className='AgreementBox-checkin' type='checkbox' onChange={() => SetAgreed(checkInRef.current.checked)} ref={checkInRef}/>
                <span className='AgreementBox-checklbl'>I've Read And Agreed To The Above Terms.</span>
            </div>
            <button className='AgreementBox-done-btn' disabled={!agreed} onClick={() => OnAgreementDoneClicked()}>Done</button>
        </div>
        :
        <Fragment></Fragment>
    );   
}
export default AgreementBox;